var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 241 256",
    enableBackground: "new 0 0 241 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.785,40.548c-10.105-2.327-31.558-7-65.995-7c-3.037,0-22.744,0-22.744,0l-3.815-4.781 c-8.755-10.973-20.496-19.165-33.825-23.572L96.773,2l-0.039,26.165c0,6.507-4.318,12.176-10.549,14.029 c-10.598,3.155-20.901,7.542-27.526,10.578C24.607,68.389,2.306,93.105,2.306,119.605c0,28.512,24.282,50.842,62.584,64.131 c-1.094,4.643-1.686,9.474-1.686,14.453c0,24.213,13.635,45.242,33.648,55.81c-5.077-11.436-7.897-24.085-7.897-37.404 c0-34.693,19.126-64.92,47.421-80.694c-3.283-0.532-6.645-0.808-10.076-0.808c-24.41,0-45.557,13.861-56.057,34.141 c-8.189-3.497-18.377-11.039-18.377-21.407c0-9.771,7.969-15.445,15.784-16.5c42.804-5.778,58.975-7.552,95.246-16.119 c22.251-5.255,38.666-12.363,49.954-22.103c0.946-0.887,0.72-2.475-0.453-3.046c-8.064-3.904-29.458-4.545-41.091-4.584 c-0.01,0-0.02-0.01-0.03-0.01c-3.687-0.03-3.391-3.332-1.39-4.584c6.773-4.032,15.321-6.832,24.726-8.538l3.598,6.586l8.173-7.848 l3.273,10.184l8.479-10.342l4.703,11.791c0-0.01,0.01-0.01,0.01-0.01l7.798-11.89c4.397-8.203,6.684-15.843,7.867-21.117 C239.41,45.576,236.896,41.494,232.785,40.548z M189.712,50.939h-0.069l-5.679-0.128c-2.11-0.039-3.786-1.775-3.746-3.874 c0.039-2.08,1.735-3.746,3.815-3.746h0.069l5.679,0.128c2.1,0.039,3.776,1.775,3.736,3.884 C193.488,49.273,191.792,50.939,189.712,50.939z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShark2);
export default __webpack_public_path__ + "static/media/shark-2.68195c67f847fc09bffa7bd9a4fbc7e4.svg";
export { ForwardRef as ReactComponent };